import { useLayoutEffect, useState } from "react";

// Measures the actually-rendered Recharts ReferenceArea rect (the shaded "current"
// region) so the "Current" caption above the chart can be pixel-aligned to it,
// instead of guessing its position from category count / axis width assumptions.
export function useReferenceAreaBox(active, wrapRef, deps) {
  const [box, setBox] = useState(null);

  useLayoutEffect(() => {
    if (!active || !wrapRef.current) {
      setBox(null);
      return undefined;
    }
    const wrap = wrapRef.current;

    const measure = () => {
      const rectEl = wrap.querySelector(".recharts-reference-area-rect");
      if (!rectEl) return;
      const wrapBox = wrap.getBoundingClientRect();
      const rectBox = rectEl.getBoundingClientRect();
      setBox((prev) => {
        const next = { left: rectBox.left - wrapBox.left, width: rectBox.width };
        if (prev && Math.abs(prev.left - next.left) < 0.5 && Math.abs(prev.width - next.width) < 0.5) return prev;
        return next;
      });
    };

    measure();
    const mutationObserver = new MutationObserver(measure);
    mutationObserver.observe(wrap, { attributes: true, attributeFilter: ["x", "width", "d"], subtree: true });
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(wrap);

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, wrapRef, ...deps]);

  return box;
}
